export default __webpack_public_path__ + "static/char-s-62-zh-Hans-1d060d2c702d97963cc8e21671777d07.webp";